import { render, staticRenderFns } from "./EMTrademarkInfo.vue?vue&type=template&id=fd2503b6&scoped=true&"
import script from "./EMTrademarkInfo.vue?vue&type=script&lang=js&"
export * from "./EMTrademarkInfo.vue?vue&type=script&lang=js&"
import style0 from "./EMTrademarkInfo.vue?vue&type=style&index=0&id=fd2503b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2503b6",
  null
  
)

export default component.exports